import { UserActionTypes } from "./user.types";

export const setUserName = username => (
    {
        type: UserActionTypes.SET_USERNAME,
        payload:username
    }
)

export const setFirstName = firstName => (
    {
        type: UserActionTypes.SET_FIRST_NAME,
        payload:firstName
    }
)

export const setLastName = lastName => (
    {
        type: UserActionTypes.SET_LAST_NAME,
        payload:lastName
    }
)

export const setToken = token => (
    {
        type: UserActionTypes.SET_USER_TOKEN,
        payload:token
    }
)

export const resetUserData = () => ({
    type: UserActionTypes.RESET_USER_DATA
})
